module.exports = __webpack_public_path__ + "img/1.d5695c54.png";